var _react_refresh_temp_1;
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
const activeSpeakerAdapter = createEntityAdapter({
    selectId: (speaker) => speaker.userId,
    sortComparer: (a, b) => {
        if (a.isSpeaking && b.isSpeaking) {
            return a.audioLevel - b.audioLevel;
        }
        if (a.isSpeaking !== b.isSpeaking) {
            if (a.isSpeaking) {
                return -1;
            }
            else {
                return 1;
            }
        }
        // last active speaker first
        if (a.lastSpokeAt !== b.lastSpokeAt) {
            return b.lastSpokeAt - a.lastSpokeAt;
        }
        return 0;
    },
});
export const activeSpeakersSelector = activeSpeakerAdapter.getSelectors(_react_refresh_temp_1 = (state) => state.activeSpeakers);
$RefreshReg$(_react_refresh_temp_1, "activeSpeakersSelector$activeSpeakerAdapter.getSelectors");
const activeSpeakersSlice = createSlice({
    name: 'activeSpeakers',
    initialState: activeSpeakerAdapter.getInitialState(),
    reducers: {
        addSpeaker: activeSpeakerAdapter.addOne,
        addManySpeakers: activeSpeakerAdapter.addMany,
        setAllSpeakers: activeSpeakerAdapter.setAll,
        removeSpeakers: activeSpeakerAdapter.removeAll,
        removeOneSpeaker: activeSpeakerAdapter.removeOne,
    },
});
export const { addSpeaker, addManySpeakers, removeSpeakers, removeOneSpeaker, setAllSpeakers, } = activeSpeakersSlice.actions;
export default activeSpeakersSlice.reducer;
